const topNav = document.querySelector('#homeStickyheader');

if (topNav) {
    const supportsIntersectionObserver = 'IntersectionObserver' in window;
    const visibleIntersectionElement = document.querySelector('[data-stickyheader="observerTarget"]');
    if (supportsIntersectionObserver) {
        const observer = new IntersectionObserver(entries => {
            if (entries[0].isIntersecting) {
                hideStickyNav();
            } else {
                showStickyNav();
            }
        }, { threshold: 0.3 });
        observer.observe(visibleIntersectionElement);
    } else {
        window.addEventListener('scroll', () => {
            const scrollTop = window.scrollY;
            if (scrollTop) {
                const windowHeight = topNav.dataset.stickyShow ? parseInt(topNav.dataset.stickyShow) : window.innerHeight;
                if (scrollTop >= windowHeight) {
                    showStickyNav();
                } else {
                    hideStickyNav();
                }
            }
        });
    }
}

function showStickyNav() {
    if (topNav.classList.contains('slideOutUp')) {
        topNav.classList.remove('slideOutUp');
        topNav.classList.add('slideInDown');
    } else {
        topNav.style.display = 'block';
        topNav.classList.add('animated');
        topNav.classList.add('slideInDown');
    }
}

function hideStickyNav() {
    if (topNav.classList.contains('slideInDown')) {
        topNav.classList.remove('slideInDown');
        topNav.classList.add('slideOutUp');
    }
}
